/* eslint-disable react/jsx-one-expression-per-line */
import { Plural, Trans } from '@lingui/macro';
import React from 'react';
import FormatNumber from '../../FormatNumber';

/* React Component */
function BillingMessage(props) {
    const { coupon } = props;

    let billingCycle = 'monthly';
    if (coupon.plan.billing_cycle === 12)
        billingCycle = 'annually';

    const planName = coupon.plan.name;
    const discountedPrice = coupon.plan.unit_price - coupon.value;
    const amount = <span>RM <FormatNumber amount={discountedPrice} /></span>;
    const applyTimes = coupon.apply_times;

    // Annual Plan
    if (billingCycle === 'annually') {
        if (applyTimes === null) {
            return (
                <Trans>
                    You are subscribing to <strong>{ planName }</strong> plan,&nbsp;
                    billed <strong>{amount} annually</strong>&nbsp;
                    until cancelled.
                </Trans>
            );
        }
        return (
            <Trans>
                You are subscribing to <strong>{ planName }</strong> plan,&nbsp;
                billed <strong>{amount} annually</strong>&nbsp;
                for <Plural
                    value={applyTimes}
                    one="first year"
                    other="first # years"
                />.
            </Trans>
        );
    }

    // Monthly Plan
    if (billingCycle === 'monthly') {
        if (applyTimes === null) {
            return (
                <Trans>
                    You are subscribing to <strong>{ planName }</strong> plan,&nbsp;
                    billed <strong>{amount} monthly</strong>&nbsp;
                    until cancelled.
                </Trans>
            );
        }
        return (
            <Trans>
                You are subscribing to <strong>{ planName }</strong> plan,&nbsp;
                billed <strong>{amount} monthly</strong>&nbsp;
                for <Plural
                    value={applyTimes}
                    one="first month"
                    other="first # months"
                />.
            </Trans>
        );
    }
}

function RestCharges(props) {
    const { coupon } = props;
    if (coupon.apply_times !== null) {
        return (
            <>
                <br />
                <br />
                <div>
                    <Trans>
                        Standard charges apply after the promotion period.&nbsp;
                        Your subscription will be automatically renewed until cancelled.
                    </Trans>
                </div>
            </>
        );
    }
    return null;
}

export function FullBillingMessage(props) {
    const { coupon } = props;

    return (
        <span>
            <BillingMessage coupon={coupon} />&nbsp;
            <Trans>
                You will be first charged after the free trial ends.
            </Trans>
            <RestCharges coupon={coupon} />
        </span>
    );
}

export function FullTrialMessage(props) {
    const { coupon } = props;

    return (
        <Trans>
            Try Bukku Elite <strong>{coupon.value}</strong> days for free.
        </Trans>
    );
}
